import classNames from 'classnames';
import React from 'react';
import './style.less';

type Props = {
    disabled: boolean;
};

export const EffectPropsGroup: React.FC<Props> = ({ disabled, children }) => {
    const cls = classNames('effect-props-group', {
        'effect-props-group--disabled': disabled,
    });

    return (
        <div className={cls}>
            <div className="effect-props-group__mask"></div>
            {children}
        </div>
    );
};
